import { t } from '@lingui/macro';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';

function EventCardSkeleton() {
    return (
        <Card className="overflow-hidden flex flex-col h-full border-solid border-border shadow-none">
            <Skeleton className="w-full aspect-[2/1] rounded-none" />
            <CardContent className="p-4 space-y-2">
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
                <Skeleton className="h-4 w-2/3" />
                <Skeleton className="h-10 w-32 mt-4 rounded-md" />
            </CardContent>
        </Card>
    );
}

export default function HostPageSkeleton() {
    return (
        <div
            className="max-w-screen-xl mx-auto px-4 pb-8 pt-4 sm:px-8"
            aria-busy="true"
            aria-label={t`Loading host`}
        >
            <Card className="border-solid border-border shadow-none">
                <CardContent className="flex flex-col items-center p-6">
                    <Skeleton className="h-9 w-2/3 max-w-xs" />
                    <Skeleton className="h-6 w-full max-w-lg mt-6" />
                    <Skeleton className="h-6 w-4/5 max-w-md mt-2" />
                    <div className="flex flex-wrap items-center justify-center gap-1 mt-8">
                        <Skeleton className="h-10 w-10 rounded-md" />
                        <Skeleton className="h-10 w-10 rounded-md" />
                        <Skeleton className="h-10 w-10 rounded-md" />
                        <Skeleton className="h-10 w-10 rounded-md" />
                    </div>
                </CardContent>
            </Card>

            <Skeleton className="h-8 w-48 mb-4 mt-8" />

            <div className="grid gap-4 md:grid-cols-2">
                <EventCardSkeleton />
                <EventCardSkeleton />
                <EventCardSkeleton />
                <EventCardSkeleton />
            </div>
        </div>
    );
}
